<script lang="ts">
import { defineComponent, h } from 'vue';

import { CdsButton } from '../CdsButton';
import {
  makeDisabledProps,
  makeIconProps,
  makeLinkProps,
  makeLoadingProps,
  makeReadonlyProps,
  useRender
} from '../../composable';

export const componentName = 'CdsFunctionalButton';
export default defineComponent({
  name: componentName,
  props: {
    ...makeIconProps(),
    ...makeDisabledProps(),
    ...makeReadonlyProps(),
    ...makeLinkProps(),
    ...makeLoadingProps()
  },
  setup(props, { slots }) {
    useRender(() =>
      h(
        CdsButton,
        {
          size: 'sm',
          appearance: 'tertiary',
          class: 'cds-functional-button',
          ...props
        },
        {
          ...slots
        }
      )
    );

    return {};
  }
});
</script>

<style lang="scss">
@import './CdsFunctionalButton';
</style>
